"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

var _amb2 = _interopRequireDefault(require("./amb.Properties"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var TransportManagement = function TransportManagement(cometd) {
  var ambTransportManagement = {};
  var LOGGER = new _amb.default('amb.TransportManagement');

  ambTransportManagement.isPruningEnabled =
  /* boolean */
  function () {
    return _amb2.default['pruneFailedTransports'] !== 'false';
  };

  ambTransportManagement.processConnectionOpened =
  /* void */
  function () {
    if (this.isPruningEnabled()) {
      LOGGER.debug("Processing connection opened");
      this.removeSkippedTransportsInConnect();
    }
  };

  ambTransportManagement.removeSkippedTransportsInConnect =
  /* void */
  function () {
    var connectedTransportType = cometd.getTransport() === null ? null : cometd.getTransport().getType();
    LOGGER.addInfoMessage("Connected using transport " + connectedTransportType);
    LOGGER.debug("Purging failed transports from registry...");

    if (connectedTransportType !== null) {
      var removed = [];

      var _iterator = _createForOfIteratorHelper(cometd.getTransportTypes()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var transportType = _step.value;
          if (transportType == connectedTransportType) break;
          cometd.unregisterTransport(transportType);
          removed.push(transportType);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      LOGGER.addInfoMessage("Removed failed registry transports after connect: {" + removed + "}");
    }
  };

  return ambTransportManagement;
};

var _default = TransportManagement;
exports.default = _default;